import React, { FC } from 'react';

import Typography from '@mui/material/Typography';

interface ErrorMessageProps {
  message?: string;
}

const ErrorMessage: FC<ErrorMessageProps> = (props) => {
  let { message } = props;
  return (
    <Typography variant="h5" style={{ fontSize: 18, color: 'red', fontWeight: 'bold' }}>
      {message}
    </Typography>
  );
};

export default ErrorMessage;
